import { render, staticRenderFns } from "./BrowsTemplates.vue?vue&type=template&id=eee468fa&scoped=true&"
import script from "./BrowsTemplates.vue?vue&type=script&lang=js&"
export * from "./BrowsTemplates.vue?vue&type=script&lang=js&"
import style0 from "./BrowsTemplates.vue?vue&type=style&index=0&id=eee468fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee468fa",
  null
  
)

export default component.exports